/* eslint-disable react/prop-types */
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import React, { useEffect } from "react";
import { timesheetActivitiesBGColor } from "./utils";

const GTabs = withStyles({
  indicator: {
    backgroundColor: "#1890ff",
    display: "none",
  },
})(Tabs);

const useStyles = (tab) =>
  makeStyles((theme) => ({
    root: {
      display: "flex",
      textTransform: "uppercase",
      minWidth: 72,
      minHeight: 36,
      maxHeight: 36,
      marginRight: 8,
      fontWeight: theme.typography.fontWeightMedium,
      borderRadius: theme.shape.borderRadius,
      "&:hover": {
        color: "#40a9ff",
        opacity: 1,
        backgroundColor: theme.palette.action.hover,
      },
      "&$selected": {
        color: "white",
        fontWeight: theme.typography.fontWeightMedium,
        backgroundColor: tab ? timesheetActivitiesBGColor(tab) : "#e8f0fe",
      },
    },
    selected: {
      color: "white",
    },
    disabled:{
      opacity:"0.2 !important",
      color:"#808080 !important"
    }
  }));

export default function GroupTabs(props) {
  const { onChange, tabs, initialSelect, setactivity, isupdateFlag, activityGroup, selectedActivityGroup } = props;
  //console.log("this is initialSelect ", initialSelect);

  const [value, setValue] = React.useState(
    isupdateFlag ? tabs.length - initialSelect - 1 : initialSelect
  );
  const classes = useStyles(tabs[value])();

  useEffect(()=>{
    if(selectedActivityGroup?.value ){
      let tabValue ;
      if(tabs[value]?.disabled === true){
         tabValue = tabs.findIndex((tab) => tab?.disabled === false);
         setactivity(tabs[tabValue]);
      }else{
         tabValue = tabs.findIndex((tab) => tab?.value?.toLowerCase() === selectedActivityGroup?.value?.toLowerCase());
      }
       setValue(tabValue);
    }
  },[tabs])

  useEffect(() => {
    setactivity(
      tabs[isupdateFlag ? tabs.length - initialSelect - 1 : initialSelect]
    );
  }, []);

  useEffect(() => {
    setValue(isupdateFlag ? tabs.length - initialSelect - 1 : initialSelect);
  }, [initialSelect]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if (onChange) {
      onChange(tabs[newValue]);
    }
  };

  return (
    <GTabs
      id="gtabs"
      value={value}
      onChange={handleChange}
      aria-label="ant example"
      variant="scrollable"
      scrollButtons="desktop"
      style={{ minHeight: 36 }}
    >
      {tabs.map((tab) => (
        <Tab
        disabled={tab.disabled}
          disableRipple
          label={tab.label}
          key={tab.value}
          classes={{
            root: classes.root,
            selected: classes.selected,
            disabled: classes.disabled
          }}
          style={{
            color:
              tabs[value]?.value == tab.value
                ? "white"
                : timesheetActivitiesBGColor(tab),
          }}
        />
      ))}
    </GTabs>
  );
}
